export const consoleAnalyticsFactory = (console) => {
    const analytics = {
        init: () => {
            console.log('ANALYTICS - Init');
            window.consoleAnalytics = analytics;
        },

        track: (eventName, extraData) =>
            console.log(`ANALYTICS - Track: ${eventName}, ${JSON.stringify(extraData)}`),

        setUser: (identity) =>
            console.log(`ANALYTICS - setUser: ${JSON.stringify(identity)}`),

        clearUser: () => console.log('ANALYTICS - clearUser'),
    };

    return analytics;
};

export default consoleAnalyticsFactory(window.console);
